<template>
  <section class="ugc-cropper-control">
    <ugc-crop-box
      :fabric-canvas="this.fabricCanvas"
      :temp-crop-data="this.tempCropData"
      :image-format="this.imageFormat"
      ref="cropbox"
    />
    <p class="ugc-cropper-control-text">
      {{ translations.ugcCropperControlDesc }}
    </p>
  </section>
</template>

<script>
/**
 * CropperControl component
 */

import BaseUgcTool from "../BaseUgcTool";
import ugcCropBox from '@/components/UGC/Tools/CropBox';

export default {
  name: "UgcCropperControl",
  extends: BaseUgcTool,
  components: {
    ugcCropBox
  },
  data() {
    return {
      controlName: "crop"
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    tempCropData() {
      const { tempData } = this.$store.state.ugc;
      const { cropper, activeUGCComponent } = tempData.features[tempData.activeUGCIndex];
      return cropper[activeUGCComponent]
        ? cropper[activeUGCComponent][this.controlName]
        : null;
    },
    imageFormat() {
      const { tempData } = this.$store.state.ugc;
      return tempData.features[tempData.activeUGCIndex].ugc_image_format;
    }
  },
  methods: {
    /**
     * Handler for the cancel button. It hides the cropbox and restore the previous applied image
     * @public
     */
    onControlCancelBack() {
      const { tempData } = this.$store.state.ugc;
      const {
        activeUGCComponent: componentName
      } = tempData.features[tempData.activeUGCIndex];
      if (tempData.features[tempData.activeUGCIndex].cropper[componentName]) {
        const canvasImage = this.fabricCanvas.getObjects("image");
        this.$refs.cropbox.loadImageMetadata({
          componentName,
          image: canvasImage[0],
          data: this.$refs.cropbox.currentImage
        });
      }
      this.$refs.cropbox.hide();
    },
    /**
     * Handler for the done button. It saves the cropper position and apply the cropped image into the Fabric canvas
     * @public
     */
    onControlDone() {
      const { tempData } = this.$store.state.ugc;
      const {
        activeUGCComponent: componentName
      } = tempData.features[tempData.activeUGCIndex];
      const canvasImage = this.fabricCanvas.getObjects("image");
      if (!canvasImage.length) {
        throw new Error("The canvas doesn't have images to crop");
      }
      this.$store.commit("ugc/tempData/SAVE_CROPPER_STATE", {
        tool: this.controlName,
        componentName,
        image: this.$refs.cropbox.getImageMetadata(canvasImage[0]),
        cropBox: {
          height: this.$refs.cropbox.cropBox.height,
          left: this.$refs.cropbox.cropBox.left,
          top: this.$refs.cropbox.cropBox.top,
          width: this.$refs.cropbox.cropBox.width
        }
      });
      const croppedArea = this.$refs.cropbox.crop();
      this.$refs.cropbox.hide();
      this.$store
        .dispatch("ugc/SET_CANVAS_IMAGE", {
          fabricCanvas: this.$store.state.ugc.stateManager.canvas,
          imageSrc: croppedArea
        })
        .then(fabricImage => {
          this.$eventBus.$emit("reload-placement-guide");
          this.$eventBus.$emit("control-finish", this.controlName);
          return Promise.resolve(fabricImage);
        });
    }
  }
};
</script>
